import { render, staticRenderFns } from "./ViewHeaderMicroSite.vue?vue&type=template&id=452f7d52&"
import script from "./ViewHeaderMicroSite.vue?vue&type=script&lang=js&"
export * from "./ViewHeaderMicroSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports